import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { useSelector } from "react-redux";
import { EditBox, AddToList, DeleteSvg, CloseSvg, LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import InputWrapper from "../components/InputWrapper";
import { SelectOptionsSection } from "../../widgets/MultiSelectOptions";
import { SelectHtml } from "../../widgets/MultiSelectOptions";
import { useEventContext } from "../../contexts/EventContextProvider";
import { updateDiscountsByVariantIdEvent, cancelVariantDiscountEditEvent } from "../../events/VariantDiscountsEditorEvents";
import { dispatch_disableTagDiscountEditEvent, dispatch_updateDiscountsByTagIdEvent } from "../../events/DiscountEvents";
import { iconsMap } from "../../icons/iconsMap";

const TagDiscountToken = (p) => {
    return (
        <li key={`li-${p.item.id}`}
            className={`ExpandableTokens_token`}>
            <span>{p.item.name}</span><figure onClick={(e) => p.onDelete(e, p.item)}><CloseSvg /></figure>
        </li>
    );
}
const tokensToList = (tokens) => {
    return Object.keys(tokens).map(key => ({ id: key, name: tokens[key] }));
};
const TagDiscountInputBar = forwardRef((p, r) => {

    const [tokens, setTokens] = useState({});
    const eventContext = useEventContext();
    const [state, setState] = useState({ discounts: [], selected: [] });
    const discounts = useSelector((state) => state.base.discounts);
    const ui_tagDiscountInputBar = useSelector((state) => state.ui.ui_tagDiscountInputBar);
    const form = useRef(null);

    useImperativeHandle(r, () => ({
        getForm: () => form.current
    }));
    const icons = {
        loading: '',
        edit: <EditBox />,
        create: <AddToList />,
        delete: <DeleteSvg />,
    };
    const actionClass = {
        edit: 'CollectionInputBar_controls_edit',
        save: 'CollectionInputBar_controls_edit',
        create: 'CollectionInputBar_controls_create',
        delete: 'CollectionInputBar_controls_delete',
    };
    useEffect(() => {
        if (Array.isArray(discounts)) {
            var list = discounts.map(discount => ({ value: discount.id, label: discount.name }));
            setState(previous => ({ ...previous, discounts: list }));
        }
    }, [discounts]);
    useEffect(() => {
        let discounts = ui_tagDiscountInputBar?.payload?.discounts;
        if (Array.isArray(discounts)) {
            setTokens(discounts.reduce((accumulator, discount) => {
                accumulator[discount.id] = discount.name;
                return accumulator;
            }, {}));
            setState(previous => ({ ...previous, selected: discounts.map(discount => ({ value: discount.id, label: discount.name })) }));
        }
    }, [ui_tagDiscountInputBar]);
    const onDiscountSelectChange = (e) => {
        //console.log('onDiscountSelectChange', e);
        if (Array.isArray(e) && e.length > 0) {
            let found = e.map(discount => {
                return { id: discount.value, name: discount.label };
            }).reduce((accumulator, current) => {
                accumulator[current.id] = current.name;
                return accumulator;
            }, {});
            setTokens(previous => ({ ...previous, ...found }));
        }
    }
    const onDelete = (e, o) => {
        e.preventDefault();
        let filtered = Object.keys(tokens)
            .filter(key => key != o.id)
            .reduce((a, c) => {
                a[c] = tokens[c];
                return a;
            }, {});
        setTokens(filtered);
    };
    const renderList = (list) => {
        return (
            (Array.isArray(list)) ?
                <div className="ExpandableTokens">
                    <div className="ExpandableTokens_slot">
                        <ul>
                            {(list.length > 0) && list.map((item, index) => {
                                return (
                                    <TagDiscountToken key={`li-${item.id}`} item={item} onDelete={(e) => onDelete(e, item)} />
                                )
                            })}
                        </ul>
                    </div>
                    <SelectHtml
                        name={'discountSelected[]'}
                        options={list ? list.map(item => ({ value: item.id, label: item.name })) : []}
                        selected={list ? list.map(item => ({ value: item.id, label: item.name })) : []}
                        multiple={true}
                        style={{ display: 'none' }} />
                </div> : <></>
        );
    }
    const onSave = (id) => {
        dispatch_updateDiscountsByTagIdEvent({ form, id });
    }
    const render = (p, m) => (
        <div className="CollectionInputBar">
            <div className="CollectionInputBar_header">
                <h6 className="CollectionInputBar_title">
                    {iconsMap[m?.type]}<span>{m?.title || ''}</span>
                    <em>{p?.name || ''}</em>
                </h6>
                <div className="CollectionInputBar_controls">
                    <button onClick={dispatch_disableTagDiscountEditEvent} className="CollectionInputBar_controls_cancel">cancel</button>
                    {(m?.button) ?
                        <button onClick={() => onSave(p?.id)} className={actionClass[m?.type]} >{m?.button}</button> :
                        <></>}
                </div>
            </div>
            <form ref={form}>
                <div className="CollectionInputBar_body">
                    <div className="flex-column">
                        <div className="flex-row">
                            <input type="hidden" name="id" value={p?.id || ''} />
                            <div className="col-12">
                                <InputWrapper label={'selected discounts'}>
                                    <SelectOptionsSection
                                        name='discounts[]'
                                        multiple={true}
                                        options={state.discounts}
                                        selected={state.selected}
                                        onChange={onDiscountSelectChange}
                                        className={''}
                                    />
                                </InputWrapper>
                            </div>
                        </div>
                        <div className="flex-row">
                            <div className="col-24">
                                <InputWrapper label={'Applied discounts'}>
                                    {renderList(tokensToList(tokens))}
                                </InputWrapper>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );

    const renderCase = (state, render) => {
        switch (state?.status) {
            case 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case 'DONE':
                //console.log('VariantDiscountInputBar', state);
                return render(state.payload, state.meta);
            case 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }
    //console.log('TagDiscountInputBar', ui_tagDiscountInputBar, p.id);
    return renderCase(ui_tagDiscountInputBar, render);
});

export default TagDiscountInputBar;
